import { render, staticRenderFns } from "./HelpCallPopupComponent.vue?vue&type=template&id=ca6a00f8&"
import script from "./HelpCallPopupComponent.vue?vue&type=script&lang=js&"
export * from "./HelpCallPopupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports